export const addCredits = [
    {
        key: 'add_credits',
        type: 'number',
        value: '',
        valid: false,
        elementConfig: {
            name: 'add_credits',
            label: 'No of Credits:',
            placeholder: ''
        },
        validation: {
            required: true,
            min: 1,
            max: 9999,
            message: "Please enter a valid whole number between 1 and 9999"
        },

    },
]

export const revokeCredits = [
    {
        key: 'revoke_credits',
        type: 'number',
        value: '',
        valid: false,
        elementConfig: {
            name: 'revoke_credits',
            label: 'No of Credits:',
            placeholder: ''
        },
        validation: {
            required: true,
            min: 1,
            max: 9999,
            message: "Please enter a valid whole number between 1 and 9999"
        },

    },
]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/ManageCredits/formdata.js